// jQuery shim — ensures all modules get the same jQuery instance on window.
// Aliased as "jquery" in esbuild.config.mjs.
// Uses require() + module.exports to stay CJS-compatible (for UMD libs like slick, select2).
const jQuery = require('../../../node_modules/jquery/dist/jquery.js');

window.jQuery = jQuery;
window.$ = jQuery;

module.exports = jQuery;
